import { c as _c } from "react/compiler-runtime";
import { Divider, Skeleton } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { INTEGRATION_TILE_WIDTH } from "@pages/project-details/project-integrations/project-integrations-constants";
import { cardProperties } from "@utils/ui-utils";

/** Skeleton loading for the integration tile */
export function IntegrationTileSkeleton() {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      width: INTEGRATION_TILE_WIDTH,
      height: "200px",
      marginTop: cardProperties.marginTop,
      boxShadow: cardProperties.boxShadow,
      borderRadius: cardProperties.borderRadius,
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Skeleton variant="rectangular" sx={{
      width: "30%",
      height: "20px"
    }} />;
    t2 = <Skeleton variant="text" />;
    t3 = <Skeleton variant="text" width="70%" />;
    t4 = <Divider />;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      display: "flex",
      justifyContent: "flex-end"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Box component="div" sx={t0}>{t1}{t2}{t3}{t4}<Box sx={t5}><Skeleton variant="text" sx={{
          width: "25%"
        }} /></Box></Box>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}